import { FaBatteryFull, FaCogs, FaIndustry, FaShieldAlt } from "react-icons/fa";
import gb2 from "../../assets/Product_img/gb_II/1.jpg";
import gb3 from "../../assets/Product_img/gb_III/1.jpeg";
import gb4 from "../../assets/Product_img/gb_IV/1.jpg";
import gbcustom from "../../assets/Product_img/gb_custom/1.jpg";
import batteryrnd from "../../assets/appication/battery_R_n_D.webp";
import profPic2 from "../../assets/profile_img/img.png";
import chemicalRnD from "../../assets/appication/chemical_research.jpg";
import nano from "../../assets/appication/nano.jpeg";
import nuclear from "../../assets/appication/nuclear_lab.jpg";
import oled from "../../assets/appication/oled.webp";
import filter from "../../assets/Accessories/Filter.jpeg";
import gasket from "../../assets/Accessories/Gasket.jpeg";
import valve from "../../assets/Accessories/Valve.jpeg";
import accesories2 from "../../assets/Accessories/accessories-2.jpeg";
import gloves from "../../assets/Accessories/gloves.jpeg";
import lid from "../../assets/Accessories/lid.jpeg";
import lid2 from "../../assets/Accessories/lid2.jpeg";
import sealBelt from "../../assets/Accessories/seal_belt.jpeg";
import spikeBoard from "../../assets/Accessories/spike_board.jpeg";
import cl_1 from "../../assets/client_logo/momentive.png";
import cl_2 from "../../assets/client_logo/jain.png";
import cl_3 from "../../assets/client_logo/bms.png";  
import cl_4 from "../../assets/client_logo/shintech.png";
import cl_5 from "../../assets/client_logo/tifr.png";
import cl_6 from "../../assets/client_logo/iith.png";
import cl_7 from "../../assets/client_logo/rv.png";
import cl_8 from "../../assets/client_logo/iisc.png";
export const HomeData = {
  hero: {
    titleOne: "Engineering Excellence in",
    titleTwo: "Controlled Atmosphere Systems",
    description:
      "Designing and manufacturing high-performance glovebox solutions for advanced research, industrial manufacturing, and mission-critical laboratory environments worldwide.",
    primaryCta: "Explore Gloveboxes",
    secondaryCta: "Request Consultation",
  },

  whyChooseUs: {
    title: "Why Choose",
    subTitle: "ProRes Glovebox",
    description:
      "Trusted by leading research institutions and industrial laboratories, ProRes delivers precision-engineered glovebox systems with uncompromising performance, reliability, and safety.",
    features: [
      {
        icon: <FaShieldAlt />,
        title: "Ultra-High Purity Atmosphere Control",
        desc: "Achieve and maintain oxygen and moisture levels below <1 ppm using advanced purification, pressure regulation, and leak-proof chamber engineering.",
      },
      {
        icon: <FaBatteryFull />,
        title: "Battery & Energy Research Optimized",
        desc: "Purpose-built systems for Lithium-ion, Sodium-ion, Solid-state batteries, fuel cells, and next-generation energy material research.",
      },
      {
        icon: <FaIndustry />,
        title: "Industrial-Grade Build Quality",
        desc: "Constructed with premium SS-304 stainless steel, precision welding, hermetic sealing, and long-life components for continuous operation.",
      },
      {
        icon: <FaCogs />,
        title: "Custom Engineered Solutions",
        desc: "Fully customizable gloveboxes including multi-chamber systems, automation interfaces, PLC control, analyzers, robotic integration, and special process modules.",
      },
    ],
  },

OurProducts: {
  title: "Our Products",
  subTitle: "ProRes Glovebox Systems",
  description:
    "Precision-engineered glovebox systems offering controlled inert environments for research, industrial, and advanced material applications.",
  productsList: [
    {
      title: "Pro-Lab GB II",
      desc: "A reliable laboratory glovebox system designed for routine inert atmosphere applications, offering stable oxygen and moisture control for academic and industrial research.",
      image:
        gb2,
    },
    {
      title: "Pro-Lab GB III",
      desc: "An advanced glovebox system with integrated gas purification and monitoring, suitable for battery research, nanotechnology, and sensitive material handling.",
      image:
        gb3
    },
    {
      title: "Pro-Lab GB IV",
      desc: "A high-performance glovebox delivering ultra-low oxygen and moisture levels, engineered for demanding applications such as lithium-ion battery development and semiconductor research.",
      image:
        gb4
    },
    {
      title: "Pro-Lab GB Custom",
      desc: "Fully customized glovebox solutions tailored to specific research workflows, space constraints, and advanced process requirements with modular and scalable configurations.",
      image:
        gbcustom
    },
  ],
},


  ourApplication: {
    title: "Applications",
    subTitle: "Industries We Serve",
    applicationList: [
      {
        id: "Application 01",
        title: "Battery Research & Development",
        desc: "Controlled inert environments for electrode fabrication, electrolyte handling, cell assembly, and advanced battery material research.",
        img: batteryrnd,
        forceRight: false,
      },
      {
        id: "Application 02",
        title: "Chemical & Pharmaceutical Research",
        desc: "Safe and contamination-free handling of air-sensitive, toxic, and reactive chemical compounds.",
        img: chemicalRnD,
        forceRight: true,
      },
      {
        id: "Application 03",
        title: "Nuclear & Defense Laboratories",
        desc: "High-security containment systems designed for nuclear material handling and defense research facilities.",
        img: nuclear,
        forceRight: false,
      },
      {
        id: "Application 04",
        title: "OLED & Semiconductor Research",
        desc: "Ultra-low oxygen and moisture environments supporting OLED fabrication and semiconductor material processing.",
        img: oled,
        forceRight: true,
      },
      {
        id: "Application 05",
        title: "Advanced Materials & Nanotechnology",
        desc: "Precision gloveboxes for graphene, nanomaterials, and emerging advanced material research.",
        img: nano,
        forceRight: false,
      },
    ],
  },

  Accessories: {
    title: "High-Quality Components",
    subTitle: "Accessories & Spare Parts",
   accList: [
      {
        title: "Gloves",
        img: gloves,
        oldPrice: "",
        newPrice: "",
      },
      {
        title: "Filter",
        img: filter,
        oldPrice: "",
        newPrice: "",
      },
      {
        title: "Gasket",
        img: gasket,
        oldPrice: "",
        newPrice: "",
      },
      {
        title: "Valve",
        img: valve,
        oldPrice: "",
        newPrice: "",
      },
      {
        title: "Lid",
        img: lid2,
        oldPrice: "",
        newPrice: "",
      },
      {
        title: "Accessories",
        img: accesories2,
        oldPrice: "",
        newPrice: "",
      },
      {
        title: "Seal Belt",
        img: sealBelt,
        oldPrice: "",
        newPrice: "",
      },
      {
        title: "Spike Board",
        img: spikeBoard,
        oldPrice: "",
        newPrice: "",
      },
      {
        title: "Lid",
        img: lid,
        oldPrice: "",
        newPrice: "",
      },
    ],
  },

  brandLogo: {
    title: "Trusted By",
    subTitle: "Research & Industry Leaders",
    logoList: [
      { name: "Defense Research", img: cl_4 },
      { name: "Energy Labs", img: cl_2 },
      { name: "Research Institutes", img: cl_1 },
      { name: "Pharmaceutical R&D", img: cl_5 },
      { name: "Advanced Manufacturing", img: cl_3 },  
      { name: "Pharmaceutical R&D", img: cl_6 },
      { name: "Pharmaceutical R&D", img: cl_7 },
      { name: "Pharmaceutical R&D", img: cl_8 },
    ],
  },

  testimonials: {
    title: "Client Testimonials",
    subTitle: "WHAT OUR CLIENTS SAY",
    testimonialList: [
      {
        title: "Advanced Battery Research",
        description:
          "The Pro-Lab GB IV system consistently maintains ultra-low oxygen levels, enabling us to achieve reproducible solid-state battery results.",
        name: "Dr. Anil Kumar",
        role: "Senior Research Scientist",
        image: profPic2
      },
      {
        title: "Pharmaceutical R&D",
        description:
          "ProRes custom glovebox allowed safe handling of air-sensitive intermediates, significantly improving product stability and yield.",
        name: "Rohit Mehta",
        role: "Process Development Lead",
        image: profPic2
      },
    ],
  },

  needCustom: {
    imgUrl: "",
    title: "Need a Custom Glovebox Solution?",
    description:
      "Our engineering team specializes in designing fully customized glovebox systems tailored to your process, industry, and research requirements.",
    ctaText: "+91 98446 06132",
  },
};

